import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { appointmentActions, referralActions, headerActions, customModalActions } from '../../../actions';
import DateDivider from '../DateDivider';
import DataRow from '../DataRow';
import { HEADER, APPOINTMENTS } from '_constants';
import CancelAppointment from './CancelAppointment';
import RescheduleAppointment from './RescheduleAppointment';
import CompleteAppointment from './CompleteAppointment';
import ContentLoader from 'components/common/loaders/ContentLoader';
import DisplayStatusesInfo from '../../common/DisplayStatusesInfo';
import _ from 'lodash';
import { EXCLUDE_DISPOSITION_BUY_STATUSES, EXCLUDE_DISPOSITION_SELL_STATUSES, DISPOSITION_NAME } from '../../../constants';

class AppointmentAction extends React.Component {
  static propTypes = {
    appointmentsFetch: PropTypes.func.isRequired,
    referralFetch: PropTypes.func.isRequired,
    fetchDispositions: PropTypes.func.isRequired,
    appointments: PropTypes.object.isRequired,
    referrals: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    setHeader: PropTypes.func.isRequired,
    updateCustomModal: PropTypes.func.isRequired,
    hideCustomModal: PropTypes.func.isRequired
  }

  componentDidMount () {
    var actionName = this.props.match.params.actionName ? this.props.match.params.actionName : '';
    this.props.setHeader({
      type: HEADER.UPDATE_HEADER,
      showHeader: true,
      headerTitle: actionName.charAt(0).toUpperCase() + actionName.substr(1) + ' Appointment',
      hasBackButton: true
    });
    return Promise.all([this.props.appointmentsFetch(),
      this.props.referralFetch()]);
  }

  showOnlyNADisposition = (appointment, referral) => {
    // Checking scenarios to show only 'N/A' disposition

    // For OpportunityStatuses
    const apptOpportunities = referral?.opportunities?.filter(opp => appointment.opportunityKeys.includes(opp.opportunityKey));
    const excludeOppts = apptOpportunities.filter(opp => {
      const excludeStatuses = opp.type === 'Buyer' ? EXCLUDE_DISPOSITION_BUY_STATUSES : EXCLUDE_DISPOSITION_SELL_STATUSES;
      return excludeStatuses.includes(opp.status);
    });

    return excludeOppts.length > 0;
  }

  getSelectDisposition (dispositionList, appointment, referral) {
    const selectItems = [<option disabled value={APPOINTMENTS.SELECT_REASON} key={APPOINTMENTS.SELECT_REASON}>Select Reason</option>];
    const updatedDispositions = [];
    const dispObj = {
      selectItems,
      updatedDispositions
    };

    if (dispositionList) {
      const showOnlyNA = this.showOnlyNADisposition(appointment, referral);

      (dispositionList || []).forEach((disposition) => {
        if (disposition.mobile === true) {
          const option = <option value={disposition.disposition.dispositionKey} key={disposition.disposition.dispositionKey}>{disposition.disposition.name}</option>;
          if (showOnlyNA && disposition?.disposition?.name === DISPOSITION_NAME.NA) {
            selectItems.push(option);
            updatedDispositions.push(disposition);
            return dispObj;
          } else if (!showOnlyNA && disposition?.disposition?.name !== DISPOSITION_NAME.NA) {
            selectItems.push(option);
            updatedDispositions.push(disposition);
          }
        }
      });
    }
    return dispObj;
  }

  displayDispositionInfo = (dispositionList, header) => {
    const body = dispositionList.map(
      (disp, index) => disp.mobile === true && disp.description && _.get(disp, 'disposition.name', null) &&
        <DisplayStatusesInfo key={index} name={disp.disposition.name} description={disp.description} />);
    this.props.updateCustomModal(true, header, body, null, this.props.hideCustomModal, this.props.hideCustomModal, true, 'lg', null, 'Close', null, 'status-info-modal');
  }

  renderDetailButtons = (apptName, appointment, referral) => {
    switch (apptName) {
      case 'cancel':
        return <CancelAppointment appointment={appointment} fetchDispositions={this.props.fetchDispositions} getSelectDisposition={this.getSelectDisposition} displayDispositionInfo={this.displayDispositionInfo} referral={referral} showOnlyNADisposition={this.showOnlyNADisposition} />;
      case 'reschedule':
        return <RescheduleAppointment appointment={appointment} fetchDispositions={this.props.fetchDispositions} getSelectDisposition={this.getSelectDisposition} />;
      case 'complete':
        return <CompleteAppointment appointment={appointment} fetchDispositions={this.props.fetchDispositions} getSelectDisposition={this.getSelectDisposition} displayDispositionInfo={this.displayDispositionInfo} referral={referral} showOnlyNADisposition={this.showOnlyNADisposition} />;
      default:
        break;
    }
  }

  render () {
    var appointment = appointmentActions.getAppointmentById(this.props.appointments, this.props.match.params.appointmentId);
    var referral = referralActions.getReferralByAppointment(this.props.referrals, appointment);

    if (referral === null || appointment === null) {
      return <ContentLoader isLoading={referral === null || appointment === null} />;
    }

    return (
      <section className='page-content appointments-page details-page'>
        <div className='date-view-container'>
          <DateDivider date={appointment.startDate} />
          <DataRow appointment={appointment} shouldRedirect={false} />
        </div>
        {
          this.renderDetailButtons(this.props.match.params.actionName, appointment, referral)
        }
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    appointments: state.appointments,
    referrals: state.referrals
  };
};

const mapDispatchToProps = dispatch => ({
  appointmentsFetch: bindActionCreators(appointmentActions.fetch, dispatch),
  referralFetch: bindActionCreators(referralActions.fetch, dispatch),
  fetchDispositions: bindActionCreators(appointmentActions.fetchDispositions, dispatch),
  setHeader: bindActionCreators(headerActions.setHeader, dispatch),
  updateCustomModal: bindActionCreators(customModalActions.updateCustomModal, dispatch),
  hideCustomModal: bindActionCreators(customModalActions.hideCustomModal, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AppointmentAction));
